import {
  findDefectTypeRecordByCode,
  normalizeDefectTypeCode,
  toCatalogDefectTypeCode
} from '@/utils/defect/defectTypeDisplay';
import { localizeDefectTypeDescription } from '@/utils/reportLocaleUtils';

function rawDefectTypeCode(defect) {
  if (!defect) return '';
  const fromCodeObj =
    defect.defectCode != null && typeof defect.defectCode === 'object'
      ? defect.defectCode.code
      : defect.defectCode ?? defect.defect_code;
  const raw =
    (defect.defectType && typeof defect.defectType === 'object'
      ? defect.defectType.code
      : defect.defectType) ??
    fromCodeObj ??
    defect.code;
  if (raw == null || raw === '') return '';
  return normalizeDefectTypeCode(toCatalogDefectTypeCode(raw));
}

/**
 * 드로어용 유형 해석 한 줄 — 보고서 부록과 같은 locale `defectTypes.{CODE}`.
 * 설명이 없으면 빈 문자열 (행에서 숨김).
 *
 * @param {object} defect
 * @param {{
 *   te: (key: string) => boolean,
 *   t: (key: string) => string,
 *   parentTypes?: object[]
 * }} helpers
 * @returns {string}
 */
export function resolveDefectTypeInterpretationLine(defect, helpers = {}) {
  const { te, t, parentTypes = [] } = helpers;
  if (typeof te !== 'function' || typeof t !== 'function') {
    return '';
  }
  const code = rawDefectTypeCode(defect);
  if (!code) {
    return '';
  }
  const record = findDefectTypeRecordByCode(code, parentTypes);
  const text = localizeDefectTypeDescription(te, t, code, record?.description);
  if (text == null || String(text).trim() === '' || text === '-') {
    return '';
  }
  return String(text).trim();
}

/**
 * 결함 행 자막: 유형 해석이 있으면 그걸, 없으면 열화상 파일명.
 *
 * @param {string} interpretation
 * @param {string} fallbackDetail
 * @returns {string}
 */
export function resolveDefectDrawerCaption(interpretation, fallbackDetail) {
  const line = String(interpretation || '').trim();
  if (line) return line;
  return String(fallbackDetail || '').trim();
}
